import { ChangeDetectorRef, Component, inject, DestroyRef } from "@angular/core";
import { CardAuditTrailComponent } from "@app/card-audit-trail";
import { type IDashboardModel, isJobsBilling, isiFirmTax, isTaxprep } from "@app/views-interfaces";
import { CardModalService } from "@shared/card-modal";
import { JobsBillingCardPanelComponent } from "@app/card-modal-component/panels/card-panels/jobs-billing-card-panel";
import { TaxCardPanelComponent } from "@app/card-modal-component/panels/card-panels/tax-card-panels";
import { DashboardsService } from "@shared/dashboards-service";
import { Subscription } from "rxjs";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: "wk-card-panel",
    imports: [TaxCardPanelComponent, JobsBillingCardPanelComponent, CardAuditTrailComponent, ReactiveFormsModule],
    templateUrl: "./card-panel.component.html",
    styleUrl: "./card-panel.component.scss",
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    host: { class: "wk-cm__card-panel" },
})
export class CardPanelComponent {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dashboardsService = inject(DashboardsService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    public readonly cardModalService = inject(CardModalService);

    currentDashboard: IDashboardModel;
    currentDashboardChangedSubscription: Subscription;
    isJobsBillingCardsPanelVisible = false;
    isTaxCardsPanelVisible = false;

    constructor() {
        this.currentDashboardChangedSubscription = this.dashboardsService.currentDashboardChanged$.subscribe(() => {
            this.init();
        });

        this.destroyRef.onDestroy(() => {
            this.currentDashboardChangedSubscription.unsubscribe();
        });

        this.init();
    }

    async init() {
        this.currentDashboard = await this.dashboardsService.getCurrentDashboard();
        this.isJobsBillingCardsPanelVisible = isJobsBilling(this.currentDashboard?.ApplicationType);
        this.isTaxCardsPanelVisible = isTaxprep(this.currentDashboard?.ApplicationType) || isiFirmTax(this.currentDashboard?.ApplicationType);

        this.changeDetectorRef.detectChanges();
    }

    closeAudit() {
        this.cardModalService.auditWindowOpen.set(false);
    }
}
